import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";

function Unauthorized() {
    return (
        <div className="hold-transition">
            <Header />
            <Aside />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 text-center">
                                <h1 className="m-0 text-danger">
                                    <i className="fas fa-exclamation-triangle"></i> Acceso Denegado
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                
                <section className="content">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="card card-danger">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            <i className="fas fa-shield-alt"></i> Sin Permisos Suficientes
                                        </h3>
                                    </div>
                                    <div className="card-body text-center">
                                        <div className="mb-4">
                                            <i className="fas fa-lock" style={{fontSize: '4rem', color: '#dc3545'}}></i>
                                        </div>
                                        <h4>No tienes permisos para acceder a esta página</h4>
                                        <p className="text-muted">
                                            Tu rol de usuario no incluye los permisos necesarios para ver este contenido.
                                            Contacta al administrador del sistema si necesitas acceso.
                                        </p>
                                        <div className="mt-4">
                                            <Link to="/home" className="btn btn-primary">
                                                <i className="fas fa-home"></i> Volver al Inicio
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            
            <Footer />
        </div>
    );
}

export default Unauthorized;